/**
 * Page backgrounds: visible photo with a light scrim so text stays readable.
 */
const PageBackdrop = ({ imageUrl, imageOpacity = 0.5, overlay = 'default' }) => {
  const scrim =
    overlay === 'light' ? (
      <>
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/55 to-black/30" />
        <div className="absolute inset-0 bg-black/25" />
      </>
    ) : (
      <>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/40" />
        <div className="absolute inset-0 bg-black/35" />
      </>
    );

  return (
    <div className="absolute inset-0 pointer-events-none" aria-hidden>
      <img
        src={imageUrl}
        alt=""
        className="w-full h-full object-cover scale-105"
        style={{ opacity: imageOpacity }}
      />
      {scrim}
    </div>
  );
};

export default PageBackdrop;
